"use client";

import { c as _c } from "react/compiler-runtime";
import { useCallback, useEffect, useMemo, useState } from "react";
import { validateFile } from "@/app/[tenant]/(console)/comms/chat/window/helpers";
import { useToast } from "@/lib/use-toast";
interface UseChatFilesOptions {
  chatId: string | null | undefined;
}
interface UseChatFilesReturn {
  selectedFiles: File[];
  setSelectedFiles: React.Dispatch<React.SetStateAction<File[]>>;
  addFiles: (files: File[]) => void;
  removeFile: (index: number) => void;
  handleFileChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  previewFile: File | null;
  setPreviewFile: (file: File | null) => void;
  previewFileUrl: string | null;
  clearFiles: () => void;
}
export function useChatFiles(t0) {
  const $ = _c(22);
  const {
    chatId
  } = t0;
  const {
    toast
  } = useToast();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const [selectedFiles, setSelectedFiles] = useState(t1);
  const [previewFile, setPreviewFile] = useState(null);
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      setSelectedFiles([]);
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== chatId) {
    t3 = [chatId];
    $[2] = chatId;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  useEffect(t2, t3);
  let t4;
  bb0: {
    if (!previewFile) {
      t4 = null;
      break bb0;
    }
    let t5;
    if ($[4] !== previewFile) {
      t5 = URL.createObjectURL(previewFile);
      $[4] = previewFile;
      $[5] = t5;
    } else {
      t5 = $[5];
    }
    t4 = t5;
  }
  const previewFileUrl = t4;
  let t5;
  if ($[6] !== selectedFiles || $[7] !== toast) {
    t5 = e => {
      if (e.target.files) {
        const filesArray = Array.from(e.target.files);
        const validFiles = filesArray.filter(file => {
          const {
            isValid,
            message
          } = validateFile(file, selectedFiles.reduce(_temp, 0));
          if (!isValid) {
            toast({
              title: "File Upload Error",
              description: `${file.name}: ${message}`,
              variant: "error"
            });
          }
          return isValid;
        });
        if (validFiles.length > 0) {
          setSelectedFiles(prevFiles => [...prevFiles, ...validFiles]);
          toast({
            title: "Files Selected",
            description: `${validFiles.length} file(s) added successfully.`,
            variant: "success"
          });
        }
      }
    };
    $[6] = selectedFiles;
    $[7] = toast;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  const handleFileChange = t5;
  let t6;
  if ($[9] !== selectedFiles || $[10] !== toast) {
    t6 = files => {
      const validFiles_0 = files.filter(file_0 => {
        const {
          isValid: isValid_0,
          message: message_0
        } = validateFile(file_0, selectedFiles.reduce(_temp2, 0));
        if (!isValid_0) {
          toast({
            title: "File Upload Error",
            description: `${file_0.name}: ${message_0}`,
            variant: "error"
          });
        }
        return isValid_0;
      });
      if (validFiles_0.length > 0) {
        setSelectedFiles(prevFiles_0 => [...prevFiles_0, ...validFiles_0]);
        toast({
          title: "Files Selected",
          description: `${validFiles_0.length} file(s) added successfully.`,
          variant: "success"
        });
      }
    };
    $[9] = selectedFiles;
    $[10] = toast;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  const addFiles = t6;
  let t7;
  if ($[12] !== toast) {
    t7 = index => {
      setSelectedFiles(prevFiles_1 => prevFiles_1.filter((_, i) => i !== index));
      toast({
        title: "File Removed",
        description: "File removed.",
        variant: "info"
      });
    };
    $[12] = toast;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  const removeFile = t7;
  let t8;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = () => {
      setSelectedFiles([]);
    };
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  const clearFiles = t8;
  let t9;
  if ($[15] !== addFiles || $[16] !== handleFileChange || $[17] !== previewFile || $[18] !== previewFileUrl || $[19] !== removeFile || $[20] !== selectedFiles) {
    t9 = {
      selectedFiles,
      setSelectedFiles,
      addFiles,
      removeFile,
      handleFileChange,
      previewFile,
      setPreviewFile,
      previewFileUrl,
      clearFiles
    };
    $[15] = addFiles;
    $[16] = handleFileChange;
    $[17] = previewFile;
    $[18] = previewFileUrl;
    $[19] = removeFile;
    $[20] = selectedFiles;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  return t9;
}
function _temp2(acc_0, f_0) {
  return acc_0 + f_0.size;
}
function _temp(acc, f) {
  return acc + f.size;
}